import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

import {
    Navigation,
    Pagination,
    Autoplay,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./RelatedArticles.css";
import { Heart, Eye } from "lucide-react";

const RelatedArticles = ({ articles = [] }) => {

    if (!articles || articles.length === 0) {
        return null;
    }

    return (
        <section className="related-articles">



            <div className="related-articles-header">
                <h2>مقالات مرتبط</h2>
            </div>

            {/* <Link
                    to="/articles"
                    className="related-articles-view-all"
                >
                    مشاهده همه 
                </Link> */}



            <Swiper
                modules={[
                     Navigation,
                    Pagination,
                    Autoplay,
                ]}
                spaceBetween={8}
                slidesPerView={1.2}

                 navigation={false}
                pagination={{
                    clickable: true,
                }}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    0: {
                        slidesPerView: 1.2,
                        spaceBetween: 12,
                    },

                    576: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },

                    992: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                    },

                    1200: {
                        slidesPerView: 5,
                        spaceBetween: 16,
                    },
                }}
                className="related-articles-swiper"
            >

                {articles.map((article) => (

                    <SwiperSlide key={article.id}>

                        <article className="article-card">

                            <Link
                                to={`/articles/${article.slug}`}
                                className="article-card-image-wrapper"
                            >

                                <img
                                    src={article.image}
                                    alt={article.name}
                                    className="article-card-image"
                                    loading="lazy"
                                />

                            </Link>

                            <div className="article-card-content">

                                <Link
                                    to={`/articles/${article.slug}`}
                                    className="article-card-title"
                                >
                                    {article.name}
                                </Link>

                                {article.short_text && (
                                    <p className="article-card-excerpt">
                                        {article.short_text}
                                    </p>
                                )}

                                <div className="article-card-meta">

                                    <span>
                                        {/* نویسنده: {article.writer} */}
                                    </span>



                                </div>
                                <div className="related-articles-footer">
                                    <Link
                                        to={`/articles/${article.slug}`}
                                        className="article-card-read-more"
                                    >
                                        مطالعه مقاله
                                        <span>←</span>
                                    </Link>

                                    <span>
                                        {/* بازدید:{" "} */}
                                        {Number(article.visited).toLocaleString("fa-IR")}
                                        <Eye tooltip="50" size={20} className="eyeIcon" />

                                    </span>
                                </div>



                            </div>

                        </article>

                    </SwiperSlide>

                ))}

            </Swiper>

        </section>
    );
};

export default RelatedArticles;